import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-icloud-private-relay-warning-banner',
  templateUrl: './icloud-private-relay-warning-banner.component.html',
  styleUrl: './icloud-private-relay-warning-banner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
})
export class ICloudPrivateRelayWarningBannerComponent {
  readonly context = input<'working-time' | 'clock-register'>('working-time');
}
